export var HANDLE;
(function (HANDLE) {
    HANDLE["ROTATE"] = "ROTATE";
    HANDLE["TOP_LEFT"] = "TOP_LEFT";
    HANDLE["TOP_MIDDLE"] = "TOP_MIDDLE";
    HANDLE["TOP_RIGHT"] = "TOP_RIGHT";
    HANDLE["LEFT_MIDDLE"] = "LEFT_MIDDLE";
    HANDLE["RIGHT_MIDDLE"] = "RIGHT_MIDDLE";
    HANDLE["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    HANDLE["BOTTOM_MIDDLE"] = "BOTTOM_MIDDLE";
    HANDLE["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
})(HANDLE || (HANDLE = {}));
export var SeatingSequence;
(function (SeatingSequence) {
    SeatingSequence["NUMERIC"] = "123";
    SeatingSequence["ALPHABETIC"] = "abc";
    SeatingSequence["NUMERIC_EVEN_OR_ODD"] = "135";
})(SeatingSequence || (SeatingSequence = {}));
export var LabelsPosition;
(function (LabelsPosition) {
    LabelsPosition["LEFT"] = "left";
    LabelsPosition["RIGHT"] = "right";
    LabelsPosition["BOTH"] = "both";
    LabelsPosition["NONE"] = "none";
})(LabelsPosition || (LabelsPosition = {}));
export var TableSeatsSides;
(function (TableSeatsSides) {
    TableSeatsSides[TableSeatsSides["TOP"] = 0] = "TOP";
    TableSeatsSides[TableSeatsSides["RIGHT"] = 1] = "RIGHT";
    TableSeatsSides[TableSeatsSides["BOTTOM"] = 2] = "BOTTOM";
    TableSeatsSides[TableSeatsSides["LEFT"] = 3] = "LEFT";
})(TableSeatsSides || (TableSeatsSides = {}));
export var SHAPE;
(function (SHAPE) {
    SHAPE["MULTI_ROW"] = "multiRow";
    SHAPE["ROW"] = "row";
    SHAPE["TABLE"] = "table";
    SHAPE["ROUND_TABLE"] = "roundTable";
    SHAPE["AREA"] = "area";
    SHAPE["TEXT"] = "text";
    SHAPE["RECTANGLE"] = "rectangle";
    SHAPE["CIRCLE"] = "circle";
    SHAPE["LINE"] = "line";
    SHAPE["ICON"] = "icon";
    SHAPE["IMAGE"] = "image";
})(SHAPE || (SHAPE = {}));
export var TOOL;
(function (TOOL) {
    TOOL["SELECT"] = "select";
    TOOL["PAN"] = "pan";
    TOOL["SEATS_SELECTION"] = "seatsSelection";
    // This part must match all SHAPE element
    // Duplicating because enums cannot be extended
    TOOL["MULTI_ROW"] = "multiRow";
    TOOL["TABLE"] = "table";
    TOOL["ROUND_TABLE"] = "roundTable";
    TOOL["AREA"] = "area";
    TOOL["TEXT"] = "text";
    TOOL["RECTANGLE"] = "rectangle";
    TOOL["CIRCLE"] = "circle";
    TOOL["LINE"] = "line";
    TOOL["ICON"] = "icon";
    TOOL["BACKGROUND"] = "background";
    TOOL["IMAGE"] = "image";
})(TOOL || (TOOL = {}));
export var KEYBOARD_KEY;
(function (KEYBOARD_KEY) {
    KEYBOARD_KEY["DELETE"] = "delete";
    KEYBOARD_KEY["BACKSPACE"] = "backspace";
    KEYBOARD_KEY["SPACE"] = " ";
    KEYBOARD_KEY["ESCAPE"] = "escape";
    KEYBOARD_KEY["ENTER"] = "enter";
    KEYBOARD_KEY["UP"] = "arrowup";
    KEYBOARD_KEY["RIGHT"] = "arrowright";
    KEYBOARD_KEY["DOWN"] = "arrowdown";
    KEYBOARD_KEY["LEFT"] = "arrowleft";
    KEYBOARD_KEY["SHIFT"] = "shift";
    KEYBOARD_KEY["META"] = "meta";
})(KEYBOARD_KEY || (KEYBOARD_KEY = {}));
export var IconType;
(function (IconType) {
    IconType["enter"] = "enter";
    IconType["exit"] = "exit";
    IconType["drinks"] = "drinks";
    IconType["wc"] = "wc";
    IconType["wcMen"] = "wcMen";
    IconType["wcWomen"] = "wcWomen";
    IconType["food"] = "food";
    IconType["stairs"] = "stairs";
    IconType["elevator"] = "elevator";
    IconType["smoking"] = "smoking";
    IconType["checkroom"] = "checkroom";
    IconType["stage"] = "stage";
})(IconType || (IconType = {}));
export var IconPosition;
(function (IconPosition) {
    IconPosition["top"] = "top";
    IconPosition["bottom"] = "bottom";
})(IconPosition || (IconPosition = {}));
//# sourceMappingURL=interfaces.js.map